import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRoleTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRoleTypesQuery = { __typename?: 'query_root', roletypes: Array<{ __typename?: 'roletypes', id: number, name: string }> };


export const GetRoleTypesDocument = gql`
    query getRoleTypes {
  roletypes(order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useGetRoleTypesQuery__
 *
 * To run a query within a React component, call `useGetRoleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleTypesQuery, GetRoleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleTypesQuery, GetRoleTypesQueryVariables>(GetRoleTypesDocument, options);
      }
export function useGetRoleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleTypesQuery, GetRoleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleTypesQuery, GetRoleTypesQueryVariables>(GetRoleTypesDocument, options);
        }
// @ts-ignore
export function useGetRoleTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleTypesQuery, GetRoleTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleTypesQuery, GetRoleTypesQueryVariables>;
export function useGetRoleTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleTypesQuery, GetRoleTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleTypesQuery | undefined, GetRoleTypesQueryVariables>;
export function useGetRoleTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleTypesQuery, GetRoleTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleTypesQuery, GetRoleTypesQueryVariables>(GetRoleTypesDocument, options);
        }
export type GetRoleTypesQueryHookResult = ReturnType<typeof useGetRoleTypesQuery>;
export type GetRoleTypesLazyQueryHookResult = ReturnType<typeof useGetRoleTypesLazyQuery>;
export type GetRoleTypesSuspenseQueryHookResult = ReturnType<typeof useGetRoleTypesSuspenseQuery>;
export type GetRoleTypesQueryResult = Apollo.QueryResult<GetRoleTypesQuery, GetRoleTypesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getRoleTypes.query.gql}
 */
export async function getRoleTypes(
  variables: GetRoleTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRoleTypesQuery['roletypes']>
export async function getRoleTypes(
  variables: GetRoleTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRoleTypesQuery>
export async function getRoleTypes(
  variables: GetRoleTypesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRoleTypesQuery['roletypes'] | GetRoleTypesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRoleTypesQuery>(
    GetRoleTypesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.roletypes
}